"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Footer = function () {
    return (react_1.default.createElement("div", { className: "mt-5" },
        react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: "center" },
            "Copyright © ",
            react_1.default.createElement(react_router_dom_1.Link, { to: "https://olonnye.com" }, "olonnye"),
            " ",
            new Date().getFullYear(),
            ".")));
};
exports.default = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvQ29tcG9uZW50cy9jb21tb24vRm9vdGVyL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGdEQUErRDtBQUMvRCxxREFBd0M7QUFFeEMsNEVBQXNEO0FBRXRELElBQU0sTUFBTSxHQUFzQjtJQUNoQyxPQUFPLENBQ0wsdUNBQUssU0FBUyxFQUFDLE1BQU07UUFDbkIsOEJBQUMsb0JBQVUsSUFBQyxPQUFPLEVBQUMsT0FBTyxFQUFDLEtBQUssRUFBQyxlQUFlLEVBQUMsS0FBSyxFQUFDLFFBQVE7WUFDN0QsY0FBYztZQUNmLDhCQUFDLHVCQUFJLElBQUMsRUFBRSxFQUFDLHFCQUFxQixjQUFlO1lBQUMsR0FBRztZQUNoRCxJQUFJLElBQUksRUFBRSxDQUFDLFdBQVcsRUFBRTtnQkFDZCxDQUNULENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGtCQUFlLE1BQU0sQ0FBQyJ9